import { defaultGet } from '@bikemap/js/utility'
import { context } from '@bikemap/js/services'

const LAZY_LOAD_DISTANCE = 100

/** @type {HTMLElement} */
let container

/**
 * Initialize lazy-loaded, targeted banner.
 */
export function initUserInspiration() {
    container = document.querySelector('.user-inspiration')

    if (isContainerAboveFold()) {
        showUserInspiration()
    } else {
        lazyLoadUserInspiration()
    }
}

function lazyLoadUserInspiration() {
    const scrollListener = () => {
        if (isContainerAboveFold()) {
            showUserInspiration()
            document.removeEventListener('scroll', scrollListener)
        }
    }

    document.addEventListener('scroll', scrollListener, { passive: true })
}

/**
 * @returns {boolean}
 */
function isContainerAboveFold() {
    const offsetTop = container.getBoundingClientRect().top
    const fold = window.innerHeight + LAZY_LOAD_DISTANCE
    return offsetTop < fold
}

/**
 * Load the user banner and insert it into the container.
 */
async function showUserInspiration() {
    try {
        const { html } = await defaultGet(context.page('userInspirationUrl'))
        container.innerHTML = html
    } catch {
        container.remove()
    }
}
